module.exports = __webpack_public_path__ + "img/img-yida-s2.cd2326bd.gif";